var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10.9951,
    r: 9.5,
    stroke: "#FF9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10 0.995117C11.9778 0.995117 13.9112 1.58161 15.5557 2.68042C17.2002 3.77923 18.4819 5.34102 19.2388 7.16828C19.9957 8.99554 20.1937 11.0062 19.8079 12.946C19.422 14.8858 18.4696 16.6677 17.0711 18.0662C15.6725 19.4647 13.8907 20.4171 11.9509 20.803C10.0111 21.1888 8.00043 20.9908 6.17317 20.2339C4.34591 19.477 2.78412 18.1953 1.6853 16.5508C0.58649 14.9063 2.98642e-07 12.9729 0 10.9951L10 10.9951L10 0.995117Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconreview);
export default __webpack_public_path__ + "static/media/iconreview.5217f6947f79d1cfab0aed24b977ee33.svg";
export { ForwardRef as ReactComponent };